var map = {
	"./AutoTranslationSettings": 41,
	"./AutoTranslationSettings.coffee": 41,
	"./CostSimulator": 42,
	"./CostSimulator.coffee": 42,
	"./History": 43,
	"./History.coffee": 43,
	"./ManageLanguages": 44,
	"./ManageLanguages.coffee": 44,
	"./NavbarDigestButton": 45,
	"./NavbarDigestButton.coffee": 45,
	"./ProjectsListing": 46,
	"./ProjectsListing.coffee": 46,
	"./TeamMembers": 47,
	"./TeamMembers.coffee": 47,
	"./TranslationInterface": 48,
	"./TranslationInterface.coffee": 48,
	"./history/Comment": 9,
	"./history/Comment.coffee": 9,
	"./history/PastSegment": 10,
	"./history/PastSegment.coffee": 10,
	"./history/SourceEdit": 11,
	"./history/SourceEdit.coffee": 11,
	"./history/shared/Date": 4,
	"./history/shared/Date.coffee": 4,
	"./projects_listing/BlankSlate": 13,
	"./projects_listing/BlankSlate.coffee": 13,
	"./projects_listing/Project": 15,
	"./projects_listing/Project.coffee": 15,
	"./projects_listing/Search": 12,
	"./projects_listing/Search.coffee": 12,
	"./projects_listing/Sidebar": 14,
	"./projects_listing/Sidebar.coffee": 14,
	"./projects_listing/Summary": 19,
	"./projects_listing/Summary.coffee": 19,
	"./projects_listing/project/Bars": 17,
	"./projects_listing/project/Bars.coffee": 17,
	"./projects_listing/project/Dropdown": 16,
	"./projects_listing/project/Dropdown.coffee": 16,
	"./projects_listing/project/Users": 18,
	"./projects_listing/project/Users.coffee": 18,
	"./projects_listing/project/bars/Bar": 7,
	"./projects_listing/project/bars/Bar.coffee": 7,
	"./translation_interface/BlankSlate": 35,
	"./translation_interface/BlankSlate.coffee": 35,
	"./translation_interface/FacetedSearch": 39,
	"./translation_interface/FacetedSearch.coffee": 39,
	"./translation_interface/History": 25,
	"./translation_interface/History.coffee": 25,
	"./translation_interface/Memory": 23,
	"./translation_interface/Memory.coffee": 23,
	"./translation_interface/Panel": 29,
	"./translation_interface/Panel.coffee": 29,
	"./translation_interface/Search": 20,
	"./translation_interface/Search.coffee": 20,
	"./translation_interface/Segments": 36,
	"./translation_interface/Segments.coffee": 36,
	"./translation_interface/SelectionStats": 34,
	"./translation_interface/SelectionStats.coffee": 34,
	"./translation_interface/SelectionTags": 33,
	"./translation_interface/SelectionTags.coffee": 33,
	"./translation_interface/blank_slate/ProjectConfigCode": 5,
	"./translation_interface/blank_slate/ProjectConfigCode.coffee": 5,
	"./translation_interface/helpers/Colors": 3,
	"./translation_interface/helpers/Colors.coffee": 3,
	"./translation_interface/history/Comment": 26,
	"./translation_interface/history/Comment.coffee": 26,
	"./translation_interface/history/PastSegment": 27,
	"./translation_interface/history/PastSegment.coffee": 27,
	"./translation_interface/history/SourceEdit": 28,
	"./translation_interface/history/SourceEdit.coffee": 28,
	"./translation_interface/memory/MemoryResult": 24,
	"./translation_interface/memory/MemoryResult.coffee": 24,
	"./translation_interface/panel/IcuPlural": 32,
	"./translation_interface/panel/IcuPlural.coffee": 32,
	"./translation_interface/panel/Plural": 31,
	"./translation_interface/panel/Plural.coffee": 31,
	"./translation_interface/panel/Singular": 30,
	"./translation_interface/panel/Singular.coffee": 30,
	"./translation_interface/panel/helpers/PanelHelpers": 1,
	"./translation_interface/panel/helpers/PanelHelpers.coffee": 1,
	"./translation_interface/segments/Segment": 21,
	"./translation_interface/segments/Segment.coffee": 21,
	"./translation_interface/segments/segment/Tags": 22,
	"./translation_interface/segments/segment/Tags.coffee": 22
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54;